<template>
  <input ref="dipt" @focus="showDateInput($event)" @keydown="keypress" type="text" class="date-input" v-model="dt"/>
</template>
<script>
export default {
  //template:
  //  '<input ref="dipt" @focus="showDateInput($event)" @keydown="keypress" type="text" class="date-input" v-model="dt"/>',
  name: "dateInput",
  props: ["value", "formater"],
  computed:{
      dt:{
          get(){
              return this.value
          },
          set(vl){
            //alert(vl)
            this.$emit('input', vl);
          }
      }
  },
  methods: {
    showDateInput: function(e) {
      const ev = e||event
      var elm = ev.srcElement || e.target;
      var tmp = elm.getAttribute("class");
      if (
        tmp &&
        tmp.indexOf("date-input-readonly") === -1 &&
        (this.readOnly == true || this.disabled)
      )
        return;
      tmp = this.lan;
      var obj = {};
      obj.lan = tmp;
      obj.el = elm;
      if (!this.formater) obj.dateFmt = "yyyy-MM-dd"
      else obj.dateFmt = this.formater

      obj.onpicked = this.setDt
      obj.oncleared = this.clear
      //obj.changing = this.ichange

      WdatePicker(obj);
    },
    setDt(dp){
         this.dt=dp.cal.getNewDateStr()
    },
    clear(){
      this.dt = null
    },
    ichange(dp){
      //alert(dp.cal.getNewDateStr())
    },
    keypress(e){
      setTimeout(()=>{
        this.dt = e.target.value
      },10)
      
      this.$emit('keypress', e)
    }
  }
};
</script>
